import React from "react";
import { Row, Col, Button } from "antd";
import signature from "../../assets/signature.png";

const intl = {
  buttonText: {
    en: "Read more",
    dk: "Læs mere"
  }
};

function Block({
  anchorId,
  img,
  headline,
  headlineBody,
  body,
  invertColors,
  customClass,
  buttonTxt,
  buttonLink,
  language,
  padding,
  paddingContent,
  displaySignature
}) {
  const generalStyle = invertColors
    ? { backgroundColor: "#000", color: "#fff" }
    : { backgroundColor: "#fff", color: "#8c8c8c" };
  return (
    <Row
      id={anchorId}
      className={customClass}
      style={{ ...generalStyle, padding }}
    >
      <Col
        sm={24}
        md={{ span: 16, offset: 4 }}
        style={{ padding: paddingContent }}
      >
        <Row>
          <Col sm={24} md={{ span: 10 }}>
            {img ? (
              <img alt='block' style={{ maxHeight: "500px", width: "100%" }} src={img} />
            ) : (
              <div className="block_align align_left">
                <div>
                  <h3 className="block_headline_left">{headline}</h3>
                  <div
                    className="block_body_left"
                    style={{ color: generalStyle.color }}
                  >
                    {headlineBody}
                  </div>
                  {buttonTxt && buttonLink && (
                    <Button href={buttonLink}>{buttonTxt}</Button>
                  )}
                </div>
              </div>
            )}
          </Col>
          <Col
            sm={24}
            md={{ span: 14 }}
            style={{ position: "relative", height: "100%" }}
          >
            <div className="block_align">
              <div>
                {img && <h3>{headline}</h3>}
                <p style={img ? {} : { textAlign: "left" }}>{body}</p>
                {img && buttonLink && (
                  <Button type="primary" href={buttonLink}>
                    {intl.buttonText[language]}
                  </Button>
                )}
                {displaySignature && (
                  <div className="signature">
                    <img
                      alt='block'
                      src={signature}
                      style={{
                        width: "200px",
                        paddingTop: "20px",
                        transform: "rotate(17deg)"
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default Block;

Block.defaultProps = {
  headline: "Why ILEAD?",
  body:
    "iLead is the blalbalbl balbl ab blablalbalb labla blablalbalb blablalbalb v blablalbalb",
  displaySignature: false,
  style: {}
};



// WEBPACK FOOTER //
// ./src/components/Block/index.js